import { getAuthHeadersWithTokenOnly } from '@discover-frontend/auth';

import { API } from 'src/constants/config';
import { fetchJson } from 'src/utils/fetchJson';

import { TRIAL_ENDPOINTS } from './constants';

export type TrialStatusResponse = {
  created_at: string;
  query_count: number;
  remaining_queries: number;
  status: string;
  user_email: string;
  user_status: string;
};

const ACTIVE_TRIAL_STATUS = 'active';

/**
 * Only an explicit `active` status may unblock the authenticated bootstrap.
 * Quota (`remaining_queries`) is a per-feature concern, not a login gate.
 */
export const isTrialActive = (
  trialStatus?: Pick<TrialStatusResponse, 'status'>
): boolean => trialStatus?.status === ACTIVE_TRIAL_STATUS;

export const fetchTrialStatus = (
  signal?: AbortSignal
): Promise<TrialStatusResponse> =>
  fetchJson<TrialStatusResponse>(`${API.BASE_URL}${TRIAL_ENDPOINTS.STATUS}`, {
    method: 'GET',
    headers: getAuthHeadersWithTokenOnly(),
    signal,
  });
